import styled from "styled-components/macro";
import { Accordion, Divider } from "@ds/react";
import { MAX_CONTENT_WIDTH } from "config/resolution";

export const Container = styled.div({});

export const CustomAccordion = styled(Accordion)(({ theme: { color, spacing, breakpoint } }) => ({
  "> *": {
    marginBottom: 0,
    paddingBottom: 0,
    svg: {
      maxHeight: spacing.inline["sm"],
      maxWidth: spacing.inline["sm"],
      position: "relative",
      top: "-4px",
      left: "-4px",
    },
    "*": {
      fill: color.neutral["08"],
      color: color.neutral["08"],
    },

    "* > :last-child > span": {
      display: "block",
    },

    ":hover *": {
      fill: color.neutral["08"],
      color: color.neutral["08"],
    },
  },

  "> hr": {
    display: "none",
  },

  "div[class^='Accordionstyle__Head']": {
    margin: 0,
    padding: "0 16px 20px",
    fontSize: "18px",

    [breakpoint.lg()]: {
      padding: "0 36px 20px",
      fontSize: "18px",
    },

    [breakpoint.xl()]: {
      maxWidth: MAX_CONTENT_WIDTH,
      padding: "0 112px 20px",
      margin: "auto",
    },
  },
}));

export const FullDivider = styled(Divider)({
  width: "100%",
});
